"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStockInfo = exports.getZSHQData = void 0;
// import webconfig from "../../../config/web";
var apidata_1 = require("../apidata");
var webconfig = require("../../../config/web");
/**
 * 指数行情
 * @returns
 */
var getZSHQData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _url, json, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "".concat(webconfig.getWebPath("push2"), "api/qt/clist/get?pi=0&pz=10&po=1&np=1&fields=f1,f2,f3,f4,f12,f13,f14&fltt=2&invt=2&ut=13697a1cc677c8bfa9a496437bfef419&fs=i:1.000001,i:0.399001,i:0.399006,i:100.HSI,i:100.DJIA");
                return [4 /*yield*/, (0, apidata_1.getHqDate)(_url)];
            case 1:
                json = _a.sent();
                if (!(json && json.data && json.data.diff)) {
                    return [2 /*return*/];
                }
                data = json.data.diff;
                return [2 /*return*/, data || []];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getZSHQData = getZSHQData;
/**
 * 获取个股info
 * @returns
 */
var getStockInfo = function (mk, code) { return __awaiter(void 0, void 0, void 0, function () {
    var mkcode, _url, json, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mkcode = mk + '.' + code;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                _url = "".concat(webconfig.getWebPath("push2"), "api/qt/stock/get?invt=2&fltt=1&fields=f181,f58,f59,f111&secid=").concat(mkcode, "&ut=13697a1cc677c8bfa9a496437bfef419&wbp2u=2924305535875976|0|1|0|web");
                return [4 /*yield*/, $.ajax({
                        url: _url,
                        method: "GET",
                        dataType: "jsonp",
                        jsonp: "cb"
                    })];
            case 2:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/, []];
                }
                data = json.data || [];
                return [2 /*return*/, data];
            case 3:
                error_2 = _a.sent();
                return [2 /*return*/, []];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getStockInfo = getStockInfo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViaHEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ3ZWJocS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQSwrQ0FBK0M7QUFDL0Msc0NBQXVDO0FBQ3ZDLElBQU0sU0FBUyxHQUFHLE9BQU8sQ0FBQyxxQkFBcUIsQ0FBQyxDQUFBO0FBRWhEOzs7R0FHRztBQUNJLElBQUksV0FBVyxHQUFHOzs7Ozs7Z0JBRWpCLElBQUksR0FBVyxVQUFHLFNBQVMsQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLG9MQUFpTCxDQUFBO2dCQUN6TixxQkFBTSxJQUFBLG1CQUFTLEVBQUMsSUFBSSxDQUFDLEVBQUE7O2dCQUE1QixJQUFJLEdBQUcsU0FBcUI7Z0JBQ2hDLElBQUksQ0FBQyxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUU7b0JBQzFDLHNCQUFPO2lCQUNSO2dCQUNHLElBQUksR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQztnQkFFMUIsc0JBQU8sSUFBSSxJQUFJLEVBQUUsRUFBQTs7O2dCQUVqQixzQkFBTyxFQUFFLEVBQUE7Ozs7S0FFWixDQUFBO0FBYlUsUUFBQSxXQUFXLGVBYXJCO0FBR0Q7OztHQUdHO0FBQ0ksSUFBSSxZQUFZLEdBQUcsVUFBTyxFQUFpQixFQUFFLElBQVk7Ozs7O2dCQUMxRCxNQUFNLEdBQUcsRUFBRSxHQUFHLEdBQUcsR0FBRyxJQUFJLENBQUE7Ozs7Z0JBRXRCLElBQUksR0FBVyxVQUFHLFNBQVMsQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLDJFQUFpRSxNQUFNLDBFQUF1RSxDQUFBO2dCQUN0TCxxQkFBTSxDQUFDLENBQUMsSUFBSSxDQUFDO3dCQUN0QixHQUFHLEVBQUUsSUFBSTt3QkFDVCxNQUFNLEVBQUUsS0FBSzt3QkFDYixRQUFRLEVBQUUsT0FBTzt3QkFDakIsS0FBSyxFQUFFLElBQUk7cUJBQ1osQ0FBQyxFQUFBOztnQkFMRSxJQUFJLEdBQUcsU0FLVDtnQkFDRixJQUFJLENBQUMsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFO29CQUN4QixzQkFBTyxFQUFFLEVBQUM7aUJBQ1g7Z0JBQ0csSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDO2dCQUUzQixzQkFBTyxJQUFJLEVBQUE7OztnQkFFWCxzQkFBTyxFQUFFLEVBQUE7Ozs7S0FFWixDQUFBO0FBbkJVLFFBQUEsWUFBWSxnQkFtQnRCIn0=